import { render, staticRenderFns } from "./Subnavbar-configs.vue?vue&type=template&id=1e8ba613&scoped=true"
import script from "./Subnavbar-configs.vue?vue&type=script&lang=js"
export * from "./Subnavbar-configs.vue?vue&type=script&lang=js"
import style0 from "./Subnavbar-configs.vue?vue&type=style&index=0&id=1e8ba613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8ba613",
  null
  
)

export default component.exports